import React from 'react'
import styled, { keyframes } from 'styled-components'

import { giphyLightBlue, giphyAqua } from '@/styles/colors'

import CreateNewApp from '../../utils/qa-events'

const slideAnimation = keyframes`
    0% {background-position: 0;}
  100% {background-position: -300%;}
`

const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-family: 'PT Mono', monospace;
  font-size: 16px;
  background: linear-gradient(to right, ${giphyLightBlue}, ${giphyAqua}, ${giphyLightBlue});
  background-size: 300%;
  background-position: 0% 100%;
  height: 42px;
  width: 176px;
  cursor: pointer;
  border-radius: 3px;

  &:hover {
    animation: ${slideAnimation} 3s infinite linear;
  }
`

// add in link
const GetStartedButton = ({ isLogin }: { isLogin?: boolean }) => {
  if (isLogin) {
    return <Button onClick={CreateNewApp}>Create an App</Button>
  } else {
    return <Button>Get Started</Button>
  }
}

export default GetStartedButton
